import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { sections } from '../utils/sections';
import { forumHome, portalUrl } from '../utils/portal';
import { footerLegal } from '../portalLinks';
import { logoMark } from '../icons';
const t = key => app.translator.trans(`tarotportal-theme.forum.footer.${key}`);

/** The portal footer, rebuilt for the forum: brand, forum sections, portal, project, legal row. */
export default class SiteFooter extends Component {
  view() {
    const external = link => m("li", null, m("a", {
      href: portalUrl(link.path)
    }, link.label));
    return m("div", {
      className: "TpFooter"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "TpFooter-top"
    }, m("div", {
      className: "TpFooter-brand"
    }, m(Link, {
      className: "TpBrand",
      href: forumHome()
    }, m("svg", {
      viewBox: "0 0 28 28",
      fill: "none",
      "aria-hidden": "true"
    }, m.trust(logoMark)), m("span", null, "TarotPortal")), m("p", null, t('about')), m("a", {
      className: "TpPill",
      href: portalUrl('/')
    }, t('to_portal'), " \u2197")), m("div", {
      className: "TpFooter-col TpFooter-col--forum"
    }, m("p", {
      className: "TpEyebrow TpEyebrow--muted"
    }, t('forum_sections')), m("ul", null, sections().map(tag => m("li", null, m(Link, {
      href: app.route.tag(tag)
    }, tag.name()))))), m("div", {
      className: "TpFooter-col TpFooter-col--about"
    }, m("p", {
      className: "TpEyebrow TpEyebrow--muted"
    }, t('about_forum')), m("ul", null, this.aboutLinks()))), m("div", {
      className: "TpFooter-bottom"
    }, m("ul", {
      className: "TpFooter-legal"
    }, footerLegal.map(external)), m("div", {
      className: "TpFooter-base"
    }, m("p", null, "\xA9 ", new Date().getFullYear(), " TarotPortal. ", t('disclaimer')), m("p", {
      className: "TpCredit"
    }, t('credit'), ' ', m("a", {
      href: "https://sora37.studio/ru",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "SORA37.STUDIO"))))));
  }

  /** Forum-own pages: all discussions and the community subsections that describe the forum. */
  aboutLinks() {
    const links = [m(Link, {
      href: app.route('index')
    }, t('all_discussions'))];
    [app.forum.attribute('tarotportalRulesTag'), app.forum.attribute('tarotportalFeedbackTag')].forEach(slug => {
      if (!slug) return;
      const tag = app.store.getBy('tags', 'slug', slug);
      if (tag) links.push(m(Link, {
        href: app.route.tag(tag)
      }, tag.name()));
    });
    return links.map(link => m("li", null, link));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/SiteFooter', SiteFooter);